import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Table from "../../../Components/Table";
import {
    faClock,
    faEdit,
    faMapMarkerAlt,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { useState } from "react";
import ModalComponent from "../../../Components/Modais";
import CadastrarEditarPontoVenda from "./CadastrarEditarPontoVenda";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import {
    DeletarPontoDeVendaController,
    ListarPontosDeVendaController,
} from "../../../Controllers/Vendas/GestãoDeVisitas/GestãoDeVisitasControllers";
import moment from "moment";
import { ColumnDescription } from "react-bootstrap-table-next";
import { IGestaoDeVisitasPonto } from "../../../Interfaces/Vendas/GestaoDeVisitas/GestaoVisitasInterfaces";
import Swal from "sweetalert2";
import useAsyncCallback from "../../../hooks/useAsyncCallback";

export default function PontoVenda() {
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const {
        value: lstPontosVenda,
        loading: loadingPontosVenda,
        execute: ListarPontosDeVenda,
    } = useAsyncEffect(() => ListarPontosDeVendaController(), []);

    const {
        execute: DeletarPontoDeVenda,
        loading: DeletarPontoDeVendaLoading,
    } = useAsyncCallback(DeletarPontoDeVendaController);

    function rowFormatter(cell: any, row: IGestaoDeVisitasPonto) {
        return (
            <div className="card">
                <div className="card-body">
                    <div className="d-flex justify-content-between">
                        <h5 className="card-title">
                            <FontAwesomeIcon icon={faMapMarkerAlt} />{" "}
                            {row.DS_PONTO_VENDA}
                        </h5>
                        <div>
                            <button
                                className="btn btn-outline-primary btn-sm mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Children: (
                                            <CadastrarEditarPontoVenda
                                                setShow={setShow}
                                                row={row}
                                                ListarPontosDeVenda={
                                                    ListarPontosDeVenda
                                                }
                                            />
                                        ),
                                        IconHeader: faEdit,
                                        headerComponent:
                                            "Editar Ponto de Venda",
                                        noFooter: true,
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>
                            <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja excluir este ponto de venda?",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonText: "Sim",
                                        cancelButtonText: "Não",
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarPontoDeVenda(
                                                row.ID_PONTO_VENDA
                                            ).then(() => {
                                                ListarPontosDeVenda();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <p className="card-text">
                                <strong>
                                    <FontAwesomeIcon icon={faClock} /> Hora
                                    Inicial:
                                </strong>{" "}
                                {row.NR_HORA_INICIAL
                                    ? moment(
                                          row.NR_HORA_INICIAL,
                                          "HH:mm:ss"
                                      ).format("HH:mm")
                                    : "-"}
                            </p>
                            <p className="card-text">
                                <strong>
                                    <FontAwesomeIcon icon={faClock} /> Hora
                                    Final:
                                </strong>{" "}
                                {row.NR_HORA_FINAL
                                    ? moment(
                                          row.NR_HORA_FINAL,
                                          "HH:mm:ss"
                                      ).format("HH:mm")
                                    : "-"}
                            </p>
                            <p className="card-text">
                                <strong>
                                    <FontAwesomeIcon icon={faClock} />{" "}
                                    Intervalo:
                                </strong>{" "}
                                {row.NR_INTERVALO}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const columns: Array<ColumnDescription<IGestaoDeVisitasPonto>> = [
        {
            dataField: "ID_PONTO_VENDA",
            text: "",
            formatter: rowFormatter,
        },
    ];
    return (
        <div className="card card-flush p-6">
            <div className="d-flex justify-content-between mb-6">
                <h3>Ponto de Venda</h3>
                <button
                    className="btn btn-outline-success"
                    onClick={() => {
                        setShow(true);

                        setModal({
                            Children: (
                                <CadastrarEditarPontoVenda
                                    setShow={setShow}
                                    ListarPontosDeVenda={ListarPontosDeVenda}
                                />
                            ),
                            IconHeader: faPlus,
                            headerComponent: "Criar Ponto de Venda",
                            noFooter: true,
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faPlus} /> Criar Ponto de Venda
                </button>
            </div>
            <Table
                key={`${DeletarPontoDeVendaLoading}-${loadingPontosVenda}`}
                keyField="ID_PONTO_VENDA"
                data={lstPontosVenda || []}
                columns={columns}
                loading={loadingPontosVenda}
                noSearch
            />

            <ModalComponent
                ModalComponent={modal}
                show={show}
                setShow={setShow}
            />
        </div>
    );
}
